import {Application} from "@hotwired/stimulus"
import {definitionsFromContext} from "@hotwired/stimulus-webpack-helpers"

window.Stimulus = Application.start()

// controllers locais
const context = require.context('./controllers', true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

// controllers de views/templates
const viewsContext = require.context(
    './../../view/templates',
    true,
    /-controller\.js$/,
)

Stimulus.load(definitionsFromContext(viewsContext))

// controllers de vendor/eproc/ui-twig-components
const toPascalCase = str => str.replace(/(?:^\w|[A-Z]|\b\w)/g, word => word.toUpperCase()).replace(/\s+|[-_]+/g, '')

const vendorContext = require.context(
    './../../../vendor/eproc/ui-twig-components/assets/controllers',
    true,
    /-controller\.js$/,
)

Stimulus.load(definitionsFromContext(vendorContext).map(definition => ({
    ...definition,
    identifier: toPascalCase(definition.identifier),
})))